<div
  #topElement
  *ngIf="!finalResponse"
  id="cac-prequal-success-div-backGround"
  class="col-md-12 divBorder"
>
  <div id="cac-prequal-success-div-right" class="">
    <div class="divWhiteBackground">
      <div
        *ngIf="saveMeCounter != 60"
        id="save-me-timer"
        name="save-me-timer"
        class="desktop save-me-timer alert alert-warning"
      >
        This page will expire in {{ saveMeCounter }} seconds.
      </div>
      <div
        *ngIf="saveMeCounter != 60"
        id="save-me-timer"
        name="save-me-timer"
        class="mobileOnly save-me-timer-mobile alert alert-warning"
      >
        This page will expire in {{ saveMeCounter }} seconds.
      </div>
      <form
        id="cac-prequal-success-form"
        onSubmit="{this.handleSubmit}"
        class="formStyle"
      >
        <div class="wizard desktop">
          <div role="presentation" class="custom-display-inline">
            <div class="left-slot">
              <a href="/">
                <img
                  src="{{ logoURL }}"
                  alt="Credit Acceptance"
                  width="150px"
                  height="35px"
                />
              </a>
            </div>
          </div>

          <div id="cac-prequal-success" class="form-group center">
            <h2 class="congrats h3-black" id="cac-success-congrats">
              {{ formFieldData?.congrats }}
              <div>{{ formFieldData?.successPrequalified }}</div>
            </h2>
            <div class="h4-black">
              {{ formFieldData?.monthlyPaymentUpTo }}${{ monthlyPayment }}
            </div>
            <p>{{ formFieldData?.monthlyPaymentvary }}</p>
          </div>

          <div>
            <div class="imgspacing">
              <img
                src="{{ prequalImg }}"
                alt=""
                width="100%"
                (load)="onImageLoad()"
              />
              <div class="image-over-text">
                <div class="h4-black m-0" *ngIf="isImageLoaded">
                  {{ formFieldData?.monthlyPaymentValidity }}
                  {{ formFieldData?.monthlyPaymentValidityDays }}
                </div>
              </div>
            </div>
            <div class="form-group center" *ngIf="dealers.length">
              <div
                class="congrats h4-black bold center"
                *ngIf="userSelectedDealersCount === 0"
              >
                {{ formFieldData.dealerMatch0 }} {{ residenceData?.city }},
                {{ residenceData?.userState }}.
              </div>
              <div
                class="congrats h4-black bold center"
                *ngIf="userSelectedDealersCount === 1"
              >
                {{ formFieldData.dealerMatch1 }} {{ residenceData?.city }},
                {{ residenceData?.userState }}.
              </div>
              <div
                class="congrats h4-black bold center"
                *ngIf="userSelectedDealersCount === 2"
              >
                {{ formFieldData.dealerMatch2 }} {{ residenceData?.city }},
                {{ residenceData?.userState }}.
              </div>
              <div
                class="congrats h4-black bold center"
                *ngIf="userSelectedDealersCount === 3"
              >
                {{ formFieldData.dealerMatch3 }} {{ residenceData?.city }},
                {{ residenceData?.userState }}.
              </div>
            </div>
            <div class="form-group center" *ngIf="dealers.length">
              <div class="h4-black">
                {{ formFieldData.selectedDealers }}
              </div>
            </div>

            <p *ngIf="!dealers.length">
              <strong class="h4-black"
                >{{ formFieldData?.noDealersMessage }}
                <a
                  id="cac-dealer-finder-link-desktop"
                  [href]="getDealerFinderUrl()"
                  >Dealer Finder</a
                >.
              </strong>
            </p>
          </div>
        </div>
        <div class="mobileOnly wizard">
          <div role="presentation" class="heading center">
            <div class="heading">
              <a href="/">
                <img
                  src="{{ logoURL }}"
                  alt="Credit Acceptance"
                  width="150px"
                  height="35px"
                />
              </a>
            </div>
          </div>
          <div id="cac-prequal-success" class="form-group center">
            <h2 class="congrats h3-black" id="cac-success-congrats">
              {{ formFieldData?.congrats }}
              <div>{{ formFieldData?.successPrequalified }}</div>
            </h2>
            <div class="h4-black">
              {{ formFieldData?.monthlyPaymentUpTo }}${{ monthlyPayment }}
            </div>
            <p>{{ formFieldData?.monthlyPaymentvary }}</p>
          </div>

          <div class="imgspacing">
            <img src="{{ prequalImg }}" alt="" width="100%" />
            <div class="text-center">
              <div class="h4-black m-0">
                {{ formFieldData?.monthlyPaymentValidity }}
                {{ formFieldData?.monthlyPaymentValidityDays }}
              </div>
            </div>
          </div>
          <div class="form-group center" *ngIf="dealers.length">
            <div
              class="congrats h4-black bold center"
              *ngIf="userSelectedDealersCount === 0"
            >
              {{ formFieldData.dealerMatch0 }} {{ residenceData?.city }},
              {{ residenceData?.userState }}.
            </div>
            <div
              class="congrats h4-black bold center"
              *ngIf="userSelectedDealersCount === 1"
            >
              {{ formFieldData.dealerMatch1 }} {{ residenceData?.city }},
              {{ residenceData?.userState }}.
            </div>
            <div
              class="congrats h4-black bold center"
              *ngIf="userSelectedDealersCount === 2"
            >
              {{ formFieldData.dealerMatch2 }} {{ residenceData?.city }},
              {{ residenceData?.userState }}.
            </div>
            <div
              class="congrats h4-black bold center"
              *ngIf="userSelectedDealersCount === 3"
            >
              {{ formFieldData.dealerMatch3 }} {{ residenceData?.city }},
              {{ residenceData?.userState }}.
            </div>
          </div>
          <div class="form-group center" *ngIf="dealers.length">
            <div class="h4-black" *ngIf="dealers.length">
              {{ formFieldData.selectedDealers }}
            </div>
          </div>
          <p *ngIf="!dealers.length">
            <strong class="h4-black"
              >{{ formFieldData?.noDealersMessage }}
              <a
                id="cac-dealer-finder-link-mobile"
                [href]="getDealerFinderUrl()"
                >Dealer Finder</a
              >.
            </strong>
          </p>
        </div>

        <div *ngIf="dealers.length">
          <label
            id="cac-ssn-consent"
            class="osm-ssn-consent"
            [innerHTML]="osmSSNConsentContent | safeHtml"
          >
          </label>

          <div class="cac-agreement-consent">
            <input
              type="checkbox"
              aria-labelledby="cac-ssn-consent"
              id="osmSsnConsent"
              tabIndex="1"
              name="osmSsnConsent"
              (change)="onCheckboxChange($event)"
            />
            <div class="osm-agree custom-display-inline">I Agree</div>
          </div>
          <div class="osm-save-me-time">
            {{ formFieldData.saveMeTimeMessage1 }} "{{
              formFieldData.seeDealers
            }}" {{ formFieldData.saveMeTimeMessage2 }}
          </div>

          <div class="row form-group center pt-20">
            <div class="col text-center">
              <button
                id="cac-see-dealers-submit"
                class="btn btn-primary btn-default b-size center-button col-right Acceptance-Bold"
                [class.disabled]="!isUserAgreed"
                [disabled]="!isUserAgreed || isWaiting"
                (click)="handleSubmit()"
              >
                <span *ngIf="isWaiting" class="fa fa-spinner fa-spin"></span>
                <span>
                  &nbsp;
                  {{ formFieldData.seeDealers }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<capq-final-success-response
  [adobeScriptLoaded]="adobeScriptLoaded"
  [dealers]="dealers"
  [shouldLoadChatWidget]="leadCreated && chatWidgetEnabled && showWwwAiChatbot"
  [dealerApprovals]="dealerApprovals"
  [inventoryModuleEnabled]="inventoryModuleEnabled"
  *ngIf="finalResponse"
></capq-final-success-response>
